import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MenuPage } from './pages/MenuPage';
import { GameStartPage } from './pages/GameStartPage';
import { BasePage } from './pages/BasePage';
import { BattlePage } from './pages/BattlePage';
import { SettingsPage } from './pages/SettingsPage';
import './App.css';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MenuPage />} />
        <Route path="/game-start" element={<GameStartPage />} />
        <Route path="/base" element={<BasePage />} />
        <Route path="/battle" element={<BattlePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/credits" element={<div className="bg-dark-dirt flex items-center justify-center text-white font-pixel" style={{
          minHeight: 'calc(100vh - env(safe-area-inset-top, 0) - env(safe-area-inset-bottom, 0))',
          width: 'calc(100vw - env(safe-area-inset-left, 0) - env(safe-area-inset-right, 0))',
          paddingTop: 'env(safe-area-inset-top, 0)',
          paddingBottom: 'env(safe-area-inset-bottom, 0)',
          paddingLeft: 'env(safe-area-inset-left, 0)',
          paddingRight: 'env(safe-area-inset-right, 0)',
        }}>Кредиты (в разработке)</div>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
